import { StDropdown, StDropdownItem, StDropdownTrigger } from "@storytell/ui/dropdown";
import { HiSolidPlayCircle, HiSolidPlus } from "solid-icons/hi";
import { For } from "solid-js";
import { Dynamic } from "solid-js/web";
import { Dialog } from "@kobalte/core/dialog";
import { createStore } from "solid-js/store";
import { TbBellRinging, TbBrandSlack, TbMail, TbMessage2 } from "solid-icons/tb";
import { StButton } from "@storytell/ui/buttons";

/**
 * Mock component for simulating creating a repeatable action from an operation
 */
export const MockSubscribeToConcept = (props: { mount?: Node }) => {
  return (
    <Dialog>
      <Dialog.Trigger as={StButton} icon={TbBellRinging}>
        Subscribe to this Concept
      </Dialog.Trigger>
      <Dialog.Portal mount={props.mount}>
        <Dialog.Overlay class="fixed inset-0 z-50 bg-black/50 dark:bg-white/10" />
        <div class="fixed z-50 inset-0 flex items-center justify-center text-on-surface dark:text-dark-on-surface">
          <Dialog.Content class="max-h-[80vh] w-screen max-w-xl overflow-y-auto rounded-xl bg-surface dark:bg-dark-surface p-8">
            <SubscribeToConceptPanel mount={props.mount} />
          </Dialog.Content>
        </div>
      </Dialog.Portal>
    </Dialog>
  );
};

const SubscribeToConceptPanel = (props: { mount?: Node }) => {
  const destinations = [
    { text: "Send an SMS", icon: TbMessage2 },
    { text: "Send an Email", icon: TbMail },
    { text: "Send to Slack", icon: TbBrandSlack },
    { text: "Run a custom Action", icon: HiSolidPlayCircle },
  ];

  const [saved, setSaved] = createStore({
    activeTrigger: 0,
    triggerText: null as string | null,
    destinationText: null as string | null,
    activeDestination: 0,

    triggerOpen: false,
  });

  return (
    <div>
      <h3 class="font-medium text-2xl mb-2">Get notified when relevant data is added to this Concept</h3>
      {/* <p class="text mb-10"> */}
      {/*   This action will use{" "} */}
      {/*   <span class="text-lime-700 dark:text-lime-200 font-medium">{props.credits.toFixed(2)} credits</span> each time */}
      {/*   it runs. */}
      {/* </p> */}
      <p class="mb-10">(Coming Soon)</p>

      <div class="grid grid-cols-[max-content_1fr] gap-x-4 gap-y-6 items-center text-lg">
        <span>Trigger</span>

        <div>
          <textarea
            onInput={(e) => setSaved("triggerText", e.currentTarget.value)}
            rows={4}
            id="trigger-text"
            placeholder="E.g. When there is a new customer complaint about the product"
            class="text-lg mb-2 p-2 block w-full resize-none outline-none rounded ring-2 ring-emerald-600"
            value={saved.triggerText || ""}
          />
        </div>

        <span>Destination</span>

        <div>
          <StDropdown
            portalProps={{ mount: props.mount }}
            contentProps={{ class: "outline-none z-50 px-1 py-1 flex flex-col gap-1" }}
            content={
              <>
                <For each={destinations}>
                  {(item, index) => (
                    <StDropdownItem
                      class="flex items-center gap-2 text-lg rounded px-2 py-1
                    transition-colors cursor-pointer outline-none
                    focus:bg-black/10 dark:focus:bg-black/30"
                      onClick={() => setSaved("activeDestination", index())}
                    >
                      <Dynamic component={item.icon} class="size-4" />
                      <span>{item.text}</span>
                    </StDropdownItem>
                  )}
                </For>

                <a
                  href="https://go.Storytell.ai/MCP"
                  target="_blank"
                  rel="noreferrer"
                  class="flex items-center gap-2 text-lg rounded px-2 py-1
                    transition-colors cursor-pointer outline-none text-primary dark:text-blue-300 underline
                    focus:bg-black/10 dark:focus:bg-black/30"
                >
                  <HiSolidPlus class="size-4" />
                  <span>Connect via MCP Server</span>
                </a>
                <a
                  href="https://roadmap.storytell.ai/?b=6849b614a27e78cbf0557010&sortBy=upvotes%3Adesc"
                  target="_blank"
                  rel="noreferrer"
                  class="flex items-center gap-2 text-lg rounded px-2 py-1
                    transition-colors cursor-pointer outline-none text-primary dark:text-blue-300 underline
                    focus:bg-black/10 dark:focus:bg-black/30"
                >
                  <HiSolidPlus class="size-4" />
                  <span>Suggest a new destination</span>
                </a>
              </>
            }
          >
            <StDropdownTrigger
              class="flex items-center gap-2 rounded-lg px-2 py-1 border border-surface-decoration dark:border-dark-surface-decoration
        transition-colors cursor-pointer outline-none
        focus:ring-2 ring-emerald-600 dark:ring-emerald-300"
            >
              <Dynamic component={destinations[saved.activeDestination].icon} class="size-4" />
              <span>{destinations[saved.activeDestination].text}</span>
            </StDropdownTrigger>
          </StDropdown>
        </div>
      </div>
      <div class="flex mt-5 justify-end">
        <Dialog.CloseButton
          disabled
          class="bg-emerald-700 opacity-60 cursor-pointer text-white flex items-center gap-2 px-4 py-2 rounded-lg"
        >
          <HiSolidPlayCircle />
          Subscribe to Concept
        </Dialog.CloseButton>
      </div>
    </div>
  );
};
